<template>
  <div>
    <div v-if="dataJson.length == 0">
      <input
        type="file"
        name="file-input"
        :id="inputId"
        class="file-input__input"
        @change="inputFile"
        accept=".csv"
      />
      <label class="file-input__label bg-light" :for="inputId">
        <span style="color: black">
          <i class="flaticon-upload mr-2" style="color: black"></i>Upload file
        </span>
      </label>
    </div>
    <div style="height: 100%;width: 100%" class="py-1" v-else>
      <i class="fas fa-minus-circle mr-2" style="cursor: pointer;" @click="removeFile"></i>
      <span>{{ nameFile }}</span>
    </div>
  </div>
</template>

<script>
import { utils, read } from "xlsx";

export default {
  name: "UploadFile",
  props: {
    inputId: {
      type: String,
      default: "file-input"
    }
  },
  data() {
    return {
      dataJson: [],
      nameFile: ""
    }
  },
  methods: {
    removeFile() {
      this.dataJson = []
      this.nameFile = ""
      this.$emit('deleteFile')
    },
    resetData() {
      // Reset component state
      this.dataJson = []
      this.nameFile = ""
      
      // Reset file input
      const fileInput = document.getElementById(this.inputId)
      if (fileInput) {
        fileInput.value = ''
      }
    },
    async inputFile(event) {
      if (event.target.files[0].type !== 'text/csv') {
        this.$notify({
          title: 'Sai định dạng',
          message: 'File import phải là file csv',
          type: 'warning'
        });
        return
      }
      
      if (!event.target.files.length) {
        return
      }
      
      let dataImport = event.target.files[0];
      console.log(dataImport, 'dataImport');
      
      try {
        this.dataJson = await this.fileToJson(dataImport)
        console.log(this.dataJson.length, 'this.dataJson');
        
        // Convert keys to lowercase with underscores
        this.dataJson.forEach((data) => {
          Object.keys(data).forEach((key) => {
            data[this.convertKey(key)] = data[key]
            delete data[key];
          })
        })
        
        this.nameFile = event.target.files[0].name
        this.$emit("uploadFile", this.dataJson)
        
      } catch (error) {
        console.error('Error processing file:', error);
        this.$notify({
          title: 'Lỗi',
          message: 'Có lỗi xảy ra khi đọc file: ' + error.message,
          type: 'error'
        });
      }
    },
    removeVietnameseTones(str) {
      str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
      str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
      str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
      str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
      str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
      str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
      str = str.replace(/đ/g, "d");
      str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
      str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
      str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
      str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
      str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
      str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
      str = str.replace(/Đ/g, "D");
      str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
      str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
      // Remove extra spaces
      str = str.replace(/ + /g, " ");
      str = str.trim();
      // Remove punctuations
      str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, " ");
      return str;
    },
    convertKey(key) {
      let myString = this.removeVietnameseTones(key);
      let trimmedString = myString.trim();
      let formattedString = trimmedString.replace(/\s+/g, '_');
      return formattedString.toLowerCase()
    },
    fileToJson(file) {
      return new Promise((res, rej) => {
        /* Đọc file CSV trực tiếp để tránh xlsx tự động convert */
        const reader = new FileReader()
        reader.onload = (e) => {
          try {
            // Loại bỏ BOM (Byte Order Mark) nếu có để tránh sai header đầu tiên
            const rawText = e.target.result || '';
            const csvText = rawText.replace(/^\uFEFF/, '');
            console.log('Raw CSV text:', csvText);
            
            /* Parse CSV manually để giữ nguyên tất cả dữ liệu dưới dạng string */
            const lines = csvText.split('\n').filter(line => line.trim() !== '');
            if (lines.length < 2) {
              rej(new Error('File CSV phải có ít nhất 2 dòng (header + data)'));
              return;
            }
            
            // Parse header và loại bỏ BOM ở cột đầu nếu còn sót
            const headers = this.parseCSVLine(lines[0]).map((h, idx) => {
              if (idx === 0) {
                return h.replace(/^\uFEFF/, '').trim();
              }
              return h.trim();
            });
            console.log('Headers:', headers);
            
            const processedData = lines.slice(1).map((line, index) => {
              const values = this.parseCSVLine(line);
              const processedRow = {};
              
              headers.forEach((header, headerIndex) => {
                let value = values[headerIndex] || '';
                // Debug log để kiểm tra
                console.log(`Key: ${header}, Value: ${value}, Type: ${typeof value}`);
                
                // Tất cả giá trị đều là string từ CSV
                processedRow[header] = value;
              });
              
              return processedRow;
            });
            
            console.log('Processed data:', processedData);
            res(processedData);
          } catch (error) {
            rej(error);
          }
        }
        reader.onerror = (e) => {
          rej(e);
        };
        reader.readAsText(file, 'utf-8')
      });
    },
    parseCSVLine(line) {
      // Parse CSV line đơn giản để xử lý comma-separated values
      const result = [];
      let current = '';
      let inQuotes = false;
      
      for (let i = 0; i < line.length; i++) {
        const char = line[i];
        
        if (char === '"') {
          inQuotes = !inQuotes;
        } else if (char === ',' && !inQuotes) {
          result.push(current.trim());
          current = '';
        } else {
          current += char;
        }
      }
      
      result.push(current.trim());
      return result;
    },
    excelDateToDDMMYYYY(serial) {
      // Convert Excel serial date to DD-MM-YYYY format
      const utc_days = Math.floor(serial - 25569);
      const utc_value = utc_days * 86400;
      const date_info = new Date(utc_value * 1000);
      
      const day = String(date_info.getDate()).padStart(2, '0');
      const month = String(date_info.getMonth() + 1).padStart(2, '0');
      const year = date_info.getFullYear();
      
      return `${day}-${month}-${year}`;
    }
  }
}
</script>

<style scoped>
.file-input__input {
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.file-input__label {
  height: 28px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 600;
  color: white;
  padding: 2px 8px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
}
</style>
